import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ListViewType from '@components/ListViewType';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';

import { checkUserType } from '@utils/Util';

const PomListTopFilter = ({
	onAddPom,
	onCollspseFilter,
	onSetViewSetting,
	selectedBrand,
	setSelectedBrand,
	totalElements,
	selectedViewType
}) => {
	const [showColumns, setShowColumns] = useState(false);
	const [searchBrand, setSearchBrand] = useState('');
	const [allBrandList, setAllBrandList] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	const dropdownButtonRef = useRef();
	const dropdownRef = useRef();
	const navigate = useNavigate();

	const fetchBrandList = async () => {
		const modifiedData = dependentFilterList?.brandList?.map((item) => ({
			label: item.name,
			value: item.id
		}));
		const combinedBrands = [...selectedBrand, ...modifiedData];
		combinedBrands.sort((a, b) => a.label.localeCompare(b.label));
		setAllBrandList(combinedBrands);
	};

	let filteredBrands = !searchBrand
		? allBrandList
		: allBrandList.filter((item) =>
				item.label?.toString().toLowerCase().includes(searchBrand.toString().toLowerCase())
			);

	useEffect(() => {
		if (dependentFilterList) {
			fetchBrandList();
		}
	}, [dependentFilterList]);

	useEffect(() => {
		document.addEventListener('mousedown', handleOutsideClick);
		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, []);

	const handleOutsideClick = (event) => {
		if (dropdownButtonRef && dropdownButtonRef?.current?.contains(event.target)) {
			return false;
		}
		if (dropdownRef && !dropdownRef?.current?.contains(event.target)) {
			setShowColumns(false);
			setSearchBrand('');
		}
	};
	const handleCheckBox = (data) => {
		if (selectedBrand?.some((brand) => brand.value === data?.value)) {
			let tmpList = selectedBrand.filter((item) => item.value !== data.value);
			setSelectedBrand(tmpList);
		} else {
			setSelectedBrand((prev) => [...prev, data]);
			let prevAllBrandList = allBrandList.filter((brand) => brand?.value !== data.value);
			setAllBrandList([data, ...prevAllBrandList]);
		}
	};

	return (
		<div className="top-header ">
			<div className="page-title-area pb-2 d-flex align-items-center">
				<div className="d-flex align-items-center cursor-pointer" onClick={() => navigate(-1)}>
					<button className="button text size32 p-0">
						<img src={`${process.env.PUBLIC_URL}/icons/left-arrwo-dark.svg`} alt="back" />
					</button>
					<h1 className="semibold-16">POM</h1>
				</div>
			</div>
			<div className="filter-container-top filter-container-top-v2 transparent-bg">
				<div className="filters">
					<div className="filter-toggle" onClick={onCollspseFilter}>
						<img src={process.env.PUBLIC_URL + '/icons/filter24.svg'} alt="filter" />
						<span>Filter</span>
					</div>
					{totalElements && (
						<span className="items-count semibold-14 gray_dark_02 mr-2">
							{totalElements > 1 ? totalElements + ' Items' : totalElements + ' Item'}
						</span>
					)}
					<Chip />
				</div>
				<div className="filter-actions compare-filter-actions">
					<Search placeholder="POM code or name" identifier="search" />
					<ListViewType type="POM_LIST" onSelectType={(selected) => onSetViewSetting(selected)} />

					{/* {defaultViewType === LIST_VIEW_TYPE.LIST_VIEW && (
						<HorizontalScroll elementReference={elementRef.current} />
					)} */}

					<div
						className={`sort-button compare-button ${
							selectedViewType === 'NARROW_VIEW' ? 'button-disabled' : ''
						}`}
					>
						<div className="transparent-select">
							<div className="select-component">
								<div
									ref={dropdownButtonRef}
									onClick={() =>
										selectedViewType === 'LIST_VIEW'
											? setShowColumns((prev) => !prev)
											: null
									}
									className="click-box click mb-1 shadow-none bg-transparent"
								>
									<p className="regular-14 gray_dark_05">Compare</p>
									<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt />
								</div>

								<div
									className={showColumns ? 'dropdown-box' : 'dropdown-box d-none'}
									ref={dropdownRef}
								>
									<div className="m-0 search-filter">
										<div className="with-icon right-icon">
											<input
												type="text"
												placeholder="Search"
												value={searchBrand}
												onChange={(e) => setSearchBrand(e.target.value)}
											/>
											<span className="right-icon">
												<img src={`${process.env.PUBLIC_URL}/icons/search.png`} alt />
											</span>
										</div>
									</div>
									<div className="custom-chekbox pl-3 list-items scroll-y-label">
										{filteredBrands?.map((item) => {
											return (
												<div className="form-group" key={item?.value}>
													<input
														type="checkbox"
														id={item?.value}
														onChange={() => handleCheckBox(item)}
														checked={selectedBrand?.some(
															(brand) => brand.value === item?.value
														)}
														disabled={
															selectedBrand?.length === 4 &&
															!selectedBrand?.some(
																(brand) => brand.value === item?.value
															)
														}

														// onChange={() => handleCheckBox(item.value)}
														// checked={selectedBrand?.includes(item?.value)}
														// disabled={
														// 	selectedBrand?.length === 4 &&
														// 	!selectedBrand?.includes(item?.value)
														// }
													/>
													<label htmlFor={item?.value}>
														<span>{item?.label}</span>
													</label>
												</div>
											);
										})}
									</div>
								</div>
							</div>
						</div>
					</div>

					<Sort title={'POM_LIST'} removedLastModified={true} />
					<div className="add-new-design">
						<button
							className="button text size32 px-0"
							onClick={onAddPom}
							disabled={!checkUserType('ADMIN')}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
							<span className="ml-1">Add POM</span>
						</button>
					</div>
				</div>{' '}
			</div>
		</div>
	);
};

export default PomListTopFilter;
